/**
 * Static, reusable constants for the frontend.
 * Keep tracked values centralized to avoid hard-coded strings.
 */
export const DEFAULT_ROUTE = '/marketplace'
export const DEFAULT_LOGIN_ROUTE = '/login'

export const noLoginCode = ['ul_530', 'tl_530', 10001]

export enum device_mode {
  otg = 1,
  usb = 2,
}
